{
  "greeting": "Hello! How can I help you with wine today?",
  "thinking": "✨ Thinking...",
  "thinkingStep": "✨ Thinking... {step}",
  "askAboutWine": "E.g. 1990s Bordeaux Red around $1500 | Burgundy village white below $600",
  "askAboutWineFirst": "I want to buy (region + color + vintage + budget)",
  "waitingForResponse": "Waiting for response...",
  "dailyLimitReached": "You've reached the daily advisory limit. Please come back after 00:00 HKT to continue.",
  "chatHistory": "Your Chat History",
  "noChatHistory": "No chat history yet",
  "startConversation": "Start a conversation to see it here",
  "backToChat": "Back to Chat",
  "newChat": "New Chat",
  "history": "History",
  "search": "Search",
  "whatsapp": "WhatsApp",
  "wineAdvisor": "Wine Advisor",
  "chat": "Chat",
  "chatNumber": "Chat {number}",
  "wineRecommended": "{count} wine recommended",
  "winesRecommended": "{count} wines recommended",
  "justNow": "Just now",
  "minuteAgo": "{count} minute ago",
  "minutesAgo": "{count} minutes ago",
  "hourAgo": "{count} hour ago",
  "hoursAgo": "{count} hours ago",
  "dayAgo": "{count} day ago",
  "daysAgo": "{count} days ago",
  "noMessagesYet": "No messages yet",
  "perBottle": "Per Bottle",
  "priceNA": "Price N/A",
  "buyNow": "Buy Now",
  "moreInformation": "More Information",
  "share": {
    "button": "Share",
    "title": "Share Conversation",
    "description": "Share this conversation with your friends using the link below:",
    "generating": "Generating share link...",
    "error": "Failed to generate share link",
    "copy": "Copy",
    "copied": "Copied!",
    "note": "Note: This link will expire in 30 days. When someone opens this link, they will see a copy of this conversation."
  },
  "checkOutWine": "Check out this wine: {name} {vintage}",
  "linkCopied": "Link copied to clipboard!",
  "contactWhatsApp": "Contact us on WhatsApp for more options",
  "errorLoadingWine": "Sorry, I couldn't load the wine details.",
  "errorOccurred": "An error occurred while fetching the response.",
  "you": "You",
  "welcome": {
    "intro": "Welcome to WWX, I’m Zyra, your AI Wine Advisor. You can access:",
    "features": {
      "globalMarket": "Global Fine Wine Market (UK, FR, HK sellers)",
      "realTimeOffers": "Real-Time Best Offers Within Your Budget",
      "personalized": "Personalized Recommendations Just For You",
      "comparison": "Vintage & Brand Comparison Made Easy",
      "instantCheckout": "Instant Quantities & Shipping Checkout"
    },
    "question": "What can I recommend for you today?",
    "trendingPrompts": "Example Queries",
    "promptExamples": {
      "title": "How to ask:",
      "good": "✓ Good examples:",
      "bad": "✗ Avoid prompts without budget:"
    },
    "prompts": {
      "bordeaux": "Bordeaux Red around $800",
      "champagne": "Grower champagne below $2000",
      "firstGrowth": "Best offer first growth 2010-2019"
    }
  },
  "feedback": {
    "helpful": "This was helpful",
    "notHelpful": "This wasn't helpful",
    "thankYou": "Thank you for your feedback!",
    "whatDidYouLike": "What did you like?",
    "whatCouldBeImproved": "What could be improved?",
    "category": "Category",
    "selectCategory": "Select a category",
    "categories": {
      "accuracy": "Accuracy",
      "helpfulness": "Helpfulness",
      "responseSpeed": "Response Speed",
      "clarity": "Clarity",
      "other": "Other"
    },
    "comments": "Comments",
    "placeholder": "Tell us more about your experience...",
    "cancel": "Cancel",
    "submit": "Submit Feedback",
    "submitting": "Submitting..."
  },
  "auth": {
    "limitReached": "Daily Limit Reached",
    "signUpToday": "Sign Up for More Messages",
    "limitMessage": "You've reached your daily message limit. Sign up for a free account to continue the chat.",
    "benefitsMessage": "Create a free account to continue chatting and save your chat history across devices.",
    "remainingMessages": "You have {count} messages remaining today",
    "signUp": "Sign Up",
    "login": "Log In",
    "loggedInAs": "Logged in as {email}",
    "logout": "Log Out"
  }
}
